<div class="row" style="margin-top: 100px;">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header card-header-icon card-header-rose">
                <h3>Partner Form</h3>
            </div>
            <div class="card-body">
                <div class="form-group mt-2">
                    <label for="company">Company Name</label>
                    <input type="text" class="form-control" id="company" name="company" [(ngModel)]="partner.companyName"
                        aria-describedby="company">
                </div>

                <div class="form-group mt-2">
                    <label for="pocLastName">POC Last Name</label>
                    <input type="text" class="form-control" id="pocLastName" name="pocLastName" [(ngModel)]="partner.contactLastName"
                        aria-describedby="pocLastName">
                </div>

                <div class="form-group mt-2">
                    <label for="pocFirstName">POC First Name</label>
                    <input type="text" class="form-control" id="pocFirstName" name="pocFirstName" [(ngModel)]="partner.contactFirstName"
                        aria-describedby="pocFirstName">
                </div>

                <div class="form-group mt-2">
                    <label for="email">Email</label>
                    <input type="text" class="form-control" id="email" name="email" [(ngModel)]="partner.email" aria-describedby="email">
                </div>

                <div class="form-group mt-2">
                    <label for="phone">Phone</label>
                    <input type="text" class="form-control" id="phone" name="phone" [(ngModel)]="partner.phone" aria-describedby="phone">
                </div>

                <div class="form-group mt-2">
                    <label for="reason" class="bmd-label-floating">Reason for Partnership</label>
                    <select class="form-control" data-style="btn btn-link" id="reason" name="reason" [(ngModel)]="partner.reason">
                      <option>Reselling</option>
                      <option>Systems Integration (SI) Services Partner</option>
                      <option>B2B Software Integration</option>
                      <option>Deal Registration</option>
                      <option>Pricing Information/Quote</option>
                    </select>
                  </div>

                  <div class="form-group mt-2">
                    <label for="goals" class="bmd-label-floating">Partnership Goals</label>
                    <textarea name="goals" class="form-control" id="goals" rows="6" [(ngModel)]="partner.goals" required></textarea>
                  </div>

                <!-- Toolbar -->
                <button type="submit" class="btn btn-primary mr-3" (click)="save()"><i class="fas fa-save"></i>
                    Save</button>
                <button type="submit" class="btn btn-dark mr-3" (click)="back()"><i class="fas fa-backward"></i>
                    Back</button>

                <!-- Subsystem Tabs -->
                <div class="col-md-12" style="margin-top: 75px;" *ngIf="this.partner.id != ''">
                    <div class="card">
                        <div class="card-header card-header-text card-header-primary">
                          <div class="card-text">
                            <ul class="nav nav-tabs" role="tablist" id="partnerTabs">
                                <li class="nav-item">
                                    <a class="nav-link active mr-3" href="#notes" data-toggle="tab"><i class="far fa-sticky-note"></i> Notes <span *ngIf="partner.notes.length > 0" class="badge badge-pill badge-info ml-1">{{ partner.notes.length }}</span></a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link mr-3" href="#contacts" data-toggle="tab"><i class="fas fa-users"></i> Contacts <span *ngIf="partner.contacts.length > 0" class="badge badge-pill badge-info ml-1">{{ partner.contacts.length }}</span></a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link mr-3" href="#attachments" data-toggle="tab"><i class="far fa-folder-open"></i> Files <span *ngIf="partner.files.length > 0" class="badge badge-pill badge-info ml-1">{{ partner.files.length }}</span></a>
                                </li>
                            </ul>
                          </div>
                        </div>
                        <div class="card-body">
                            <!-- Tab Content -->
                            <div class="tab-content">
                                <div role="tabpanel" class="tab-pane active" id="notes">
                                    <div class="row col-md-12">
                                        <div class="col-md-3">
                                            <h3>New Note</h3>
                                            <div class="form-group">
                                                <label for="exampleFormControlTextarea1">Message</label>
                                                <textarea class="form-control" id="noteMessage" name="noteMessage" [(ngModel)]="strMessage" rows="5"></textarea>
                                              </div>
                                              <button type="submit" class="btn btn-primary mr-3" (click)="saveNote()"><i class="fas fa-save"></i>
                                                Save</button>
                                        </div>
                                        <div class="col-md-9">
                                            <h3>Notes</h3>
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th class="tableHeader">Message</th>
                                                        <th class="tableHeader">Created By</th>
                                                        <th class="tableHeader">Date Created</th>
                                                        <th class="tableHeader text-right">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let c of partner.notes">
                                                        <td>{{ c.note }}</td>
                                                        <td>{{ c.userName  }}</td>
                                                        <td>{{ c.dateCreated | date:'medium' }}</td>
                                                        <td class="td-actions text-right">
                                                            <button type="button" rel="tooltip" (click)="deleteNote(c.id)" title="Delete" class="btn btn-danger btn-lg">
                                                                <i class="fas fa-trash" style="font-size: larger;"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div role="tabpanel" class="tab-pane" id="contacts">
                                    <div class="row col-md-12">
                                        <div class="col-md-3">
                                            <h3>New Contact</h3>
                                            <div class="form-group mt-2">
                                                <label for="contactName">Name</label>
                                                <input type="text" class="form-control" id="contactName" name="contactName" [(ngModel)]="contact.name"
                                                    aria-describedby="contactName">
                                            </div>
                                            <div class="form-group mt-2">
                                                <label for="contactEmail">Email</label>
                                                <input type="text" class="form-control" id="contactEmail" name="contactEmail" [(ngModel)]="contact.email"
                                                    aria-describedby="Email">
                                            </div>
                                            <div class="form-group mt-2">
                                                <label for="contactPhone">Phone</label>
                                                <input type="text" class="form-control" id="contactPhone" name="contactPhone" [(ngModel)]="contact.phone"
                                                    aria-describedby="contactPhone">
                                            </div>
                                            <div class="form-group mt-2">
                                                <label for="contactRole">Role</label>
                                                <select class="form-control select-text" name="contactRole" [(ngModel)]="contact.role" id="contactRole"
                                                    aria-describedby="contactRole">
                                                    <option *ngFor="let s of roles">{{ s }}</option>
                                                </select>
                                            </div>
                                            <button type="submit" class="btn btn-primary mr-3" (click)="saveContact()"><i class="fas fa-save"></i>
                                                Save</button>
                                        </div>
                                        <div class="col-md-9">
                                            <h3>Contacts</h3>
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th class="tableHeader">Name</th>
                                                        <th class="tableHeader">Email</th>
                                                        <th class="tableHeader">Phone</th>
                                                        <th class="tableHeader">Role</th>
                                                        <th class="tableHeader text-right">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let c of partner.contacts">
                                                        <td>{{ c.name }}</td>
                                                        <td>{{ c.email  }}</td>
                                                        <td>{{ c.phone }}</td>
                                                        <td>{{ c.role }}</td>
                                                        <td class="td-actions text-right">
                                                            <button type="button" rel="tooltip" (click)="deleteContact(c.id)" title="Delete" class="btn btn-danger btn-lg">
                                                                <i class="fas fa-trash" style="font-size: larger;"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div role="tabpanel" class="tab-pane" id="attachments">
                                    <div class="row col-md-12">
                                        <div class="col-md-3">
                                            <h3>Upload Files</h3>
                                            <input type="file" (change)="upload($event)" id="uploader" multiple #uploader />
                                        </div>
                                        <div class="col-md-9">
                                            <h3>Files</h3>
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th class="tableHeader">Filename</th>
                                                        <th class="tableHeader">Type</th>
                                                        <th class="tableHeader">Size (bytes)</th>
                                                        <th class="tableHeader">Date Uploaded</th>
                                                        <th class="tableHeader text-right">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let c of partner.files">
                                                        <td>{{ c.fileName }}</td>
                                                        <td>{{ c.fileType  }}</td>
                                                        <td>{{ c.size }}</td>
                                                        <td>{{ c.dateUploaded | date:'medium' }}</td>
                                                        <td class="td-actions text-right">
                                                            <button type="button" rel="tooltip" (click)="download(c.id)" title="Download" class="btn btn-success btn-lg mr-4">
                                                                <i class="fas fa-download" style="font-size: larger;"></i>
                                                            </button>
                                                            <button type="button" rel="tooltip" (click)="deleteFile(c.id)" title="Delete" class="btn btn-danger btn-lg">
                                                                <i class="fas fa-trash" style="font-size: larger;"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>
